<div class="d-flex">
  @if ((date | date: 'mediumDate') === (today | date: 'mediumDate')) {
    <p class="fs-small mb-1 mt-2">{{ 'TODAY' | translate }}</p>
  }

  @if ((date | date: 'mediumDate') === (yesterday | date: 'mediumDate')) {
    <p class="fs-small mb-1 mt-2">{{ 'YESTERDAY' | translate }}</p>
  }

  @if ((date | date: 'mediumDate') !== (today | date: 'mediumDate') && (date | date: 'mediumDate') !== (yesterday | date: 'mediumDate')) {
    <p class="fs-small mb-1 mt-2">{{ date | date: 'mediumDate' }}</p>
  }
</div>
